const getDatetimeTickInterval = ({series}) => {
    const mainSeries = series.find((s) => !s.isCompare && s.data.length >= 2);
    return mainSeries && mainSeries.data[1][0] - mainSeries.data[0][0];
};
exports.getDatetimeTickInterval = getDatetimeTickInterval;
